import { Accordion, AccordionDetails, Typography, useEventCallback } from '@mui/material';
import { memo, useMemo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { ExpandMore } from '@mui/icons-material';
import { headCellsCitizenship, headCellsCitizenshipEditMode } from './constants';
import { FormikProps } from 'formik';
import { CitizenshipVM } from 'shell/view-models/citizenship';
import CitizenshipForm from 'shell/components/shared/citizenship-form';
import { HeadCell } from 'shell/components/shared/table/types';
import { RegisterOfficeVM } from 'shell/view-models/register-office-practice-vm';

interface CitizenshipProps {
  formContext: FormikProps<RegisterOfficeVM>;
  disabled?: boolean;
}

const CitizenshipComponent = ({ formContext }: CitizenshipProps): React.ReactElement => {
  const [open, setOpen] = useState(false);

  const onDelete = useEventCallback((citizen: CitizenshipVM) => {
    const citizens = formContext.values.accountholderData?.citizenship?.slice() || [];

    const filteredCitizens = citizens.filter(
      (citizeToFilter) => citizeToFilter.code !== citizen.code
    );

    formContext.setFieldValue('citizenship', filteredCitizens);
  });

  const headCells: HeadCell<CitizenshipVM, keyof CitizenshipVM>[] = useMemo(() => {
    return !formContext.values.accountholderData?.withSearch
      ? headCellsCitizenship
      : headCellsCitizenshipEditMode;
  }, [formContext.values.accountholderData?.withSearch]);

  const onAddToTable = useEventCallback((values: Array<CitizenshipVM>) => {
    formContext.setFieldValue('accountholderData', {
      ...(formContext.values.accountholderData || {}),
      citizenship: values,
    });
  });

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-citizenship-content"
        id="panel-person-citizenship-header"
        expandIcon={<ExpandMore />}
      >
        <Typography>Cittadinanza Intestatario</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <CitizenshipForm
          headCells={headCells}
          onAddToTable={onAddToTable}
          citizens={formContext.values.accountholderData?.citizenship as Array<CitizenshipVM>}
          onDelete={onDelete}
          disabled
        />
      </AccordionDetails>
    </Accordion>
  );
};

CitizenshipComponent.displayName = 'Citizenship component';

const Citizenship = memo(CitizenshipComponent);

export default Citizenship;
